export default {
  namespaced: true,
  state: {
    list: [],
    current: null,
    requestedId: null
  },
  actions: {
  },
  mutations: {
    reset (state) {
      state.list = []
      state.current = null
    },
    SET_REQUESTED_ID(state, payload) {
      state.requestedId = payload
    },
    SET_MODULES(state, payload) {
      state.list = payload
    },
    SELECT_MODULE (state, payload) {
      state.current = payload
    }
  },
  getters: {
    list: state => state.list,
    current: state => state.current,
    requestedId: state => state.requestedId
  }
}